import React from 'react';

import PropTypes from 'prop-types';
import { Typography } from '@telus-uds/components-web';

import Select from 'react-select';

const MultiSelect = ({ name, label, options, updateFilters, value, isMulti = true }) => {
  const handleSelect = selectedOption => {
    updateFilters(name, selectedOption);
  };

  // Force clearable for single select
  const isClearable = !isMulti;

  const styles = {
    option: provided => ({
      ...provided,
      borderBottom: '1px solid #e3e3e3',
      fontWeight: 100,
      color: '#555',
      backgroundColor: 'white'
    }),
    control: () => ({
      display: 'flex',
      borderRadius: '3px',
      border: '1px solid #333'
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.data.color,
      fontSize: state.selectProps.myFontSize
    }),
    clearIndicator: (provided) => ({
      ...provided,
      display: 'flex !important',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      color: '#999',
      padding: '2px',
      '&:hover': {
        color: '#333'
      }
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      display: 'flex',
      alignItems: 'center'
    }),
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 })
  };

  return (
    <div className="dropdown-main-container">
      <Typography heading="h4" variant={{ size: 'h4', bold: true }} block>{label}</Typography>
      <div className="dropdown-container">
        <Select
          value={value}
          onChange={handleSelect}
          isMulti={isMulti}
          isClearable={isClearable}
          isSearchable
          options={options}
          styles={styles}
          placeholder="Select..."
          menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
        />
      </div>
    </div>
  );
};

MultiSelect.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })).isRequired,
  updateFilters: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })),
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }),
    PropTypes.oneOf([null])
  ]).isRequired,
  isMulti: PropTypes.bool
};

export default MultiSelect;
